
        var result = require("!!../../node_modules/css-loader/index.js!./app.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 716
// module chunks = 0